import { defineAsyncComponent } from "vue";

export const SharedModal2fa = defineAsyncComponent(
  () => import("./component.vue")
);
